// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../node_modules/css-loader/index.js??ref--11-2!../node_modules/postcss-loader/index.js??postcss!../node_modules/less-loader/dist/cjs.js??ref--11-4!./styles.less");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../node_modules/style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js??ref--11-2!../node_modules/postcss-loader/index.js??postcss!../node_modules/less-loader/dist/cjs.js??ref--11-4!./styles.less", function() {
			var newContent = require("!!../node_modules/css-loader/index.js??ref--11-2!../node_modules/postcss-loader/index.js??postcss!../node_modules/less-loader/dist/cjs.js??ref--11-4!./styles.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./src/styles.less
// module id = 458
// module chunks = 2